import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import StockOrientationSelect from '../../../common/StockOrientationSelect';

const LogoImagesOrientationSelect = (props) => {
    const {
        onOrientationChange,
        logoStockImagesOrientation,
        setLogoStockImagesOrientation,
    } = props;

    return (
        <StockOrientationSelect
            onOrientationChange={onOrientationChange}
            mediaOrientation={logoStockImagesOrientation}
            setStockMediaOrientation={setLogoStockImagesOrientation}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        logoStockImagesOrientation,
        backgroundStockImagesOrientation
    } = state.mediaPicker;

    return {
        logoStockImagesOrientation,
        backgroundStockImagesOrientation
    };
}

const mapDispatchToProps = (dispatch) => {
    const setLogoStockImagesOrientation = (orientation) => dispatch(mediaPickerActions.setLogoStockImagesOrientation(orientation));

    return {
        setLogoStockImagesOrientation
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoImagesOrientationSelect);